module.exports = __webpack_public_path__ + "img/back_pocket_bag_height.c561c5c9.png";